import React, { Component } from "react";
import { Avatar, Card, Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography/Typography";
import { textBlack, textGrey, webFont } from "../../config/theme";
import { client } from '../../config/apollo';
import { GET_DISH } from '../../graphql/queries/dishes';


const defaultChefImg = "/images/simple-chef.webp";

export class Dish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dishDetails: this.props.dish,
    };
  }

  componentDidMount () {
    const { dish } = this.props;
    client.query({
      query: GET_DISH,
      variables: {
        id: dish.id,
      }
    })
      .then(dishDetails => {
        if (dishDetails.data) {
          this.setState({ dishDetails: dishDetails.data.dish });
        }
      })
      .catch(error => {
        console.log('Oops! Error fetching dish Details');
      });
  }

  openDish = (dish) => {
    this.props.history.push("/home/add-dish", {dish: this.state.dishDetails});
  };

  render() {
    const { dish } = this.props;

    let dishImg = defaultChefImg;
    const media = dish.media;
    if (media.length > 0) {
      const index = media.findIndex(item => item.size === "MEDIUM");
      if (index < 0) {
        dishImg = media[0].url;
      } else {
        dishImg = media[index].url;
      }
    }

    return (
      <div className="dish-box-container edit-portfolio-dishes" onClick={() => this.openDish(dish)}>
        <div className="dish-image">
          <img
            src={dishImg}
            alt="Image not available"
          />
        </div>
        <div className="dish-detail">
          <Typography
            align="left"
            variant="h5"
            style={style.chefName}
            gutterBottom={true}
            noWrap={true}
          >
            {dish.name}
          </Typography>
          <Typography
            align="left"
            variant="body1"
            style={style.chefCuisine}
            gutterBottom={true}
            noWrap={true}
          >
            {dish.cuisines ? dish.cuisines.length > 3 ? 'Multi cuisines' : dish.cuisines.toString() : ""}
          </Typography>
        </div>
      </div>
    );
  }
}
const style = {
  avatarImg: {
    width: '100%',
    height: 210,
    borderRadius: 5
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    marginLeft: 80,
    weight: 800,
    marginBottom: 30,
    marginTop: 30
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    fontWeight: 500,
    maxWidth: 400
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  showBtn: {
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20
  }
};
